import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as S3 from 'aws-sdk/clients/s3';
import { AppConfig } from '../app.config';
import { DocumentationRegistry, DocumentationRegistryItem } from './documentation-registry';
import { CognitoUtil } from '../authentication/cognito.service';
import * as AWS from 'aws-sdk';
import { JWTService } from '../authentication/jwt.service';
import { UserCredentialsCognito } from '../authentication/user-credentials-cognito';
import { AwsUtil } from '../authentication/aws.service';
import { DocumentationRequest, DocumentationResponse, WebApiEndpoints } from '@liquitics/transaction';
import { E } from '@angular/cdk/keycodes';

@Component({
    selector: 'app-documentation-dialog',
    templateUrl: './documentation-dialog.component.html',
    styleUrls: ['./documentation-dialog.component.scss']
})
export class DocumentationDialogComponent {
    loading = false;
    registryItems: DocumentationRegistryItem[] = [];
    selectedRegistryItem: DocumentationRegistryItem;

    videoURL: string;
    documentationCredentials: AWS.Credentials;

    constructor(
        public dialogRef: MatDialogRef<DocumentationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        // public cognitoUtil: CognitoUtil,
        private awsUtil: AwsUtil,
        private jwtService: JWTService,
        private appConfig: AppConfig) {
        this.getDocumentationRegistry();


    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    async getDocumentationRegistry() {
        this.loading = true;
        try {
            if (this.appConfig.getTenantInfo().loginStrategy === 'COGNITO') {

                const tenantId = this.appConfig.getTenantInfo().tenantId;
                const bucket = `com-liquitics-operations-${tenantId}`;
                const userCredentialsCognito = this.jwtService.getUserCredentials() as UserCredentialsCognito;
                this.documentationCredentials = userCredentialsCognito.buildCognitoCreds(await userCredentialsCognito.getIdToken(), this.appConfig.getTenantInfo());
                const s3 = new S3(this.documentationCredentials);
                const registryOutput = await s3.getObject({
                    Bucket: bucket,
                    Key: 'documentation/documentation-registry.json',
                } as S3.Types.GetObjectRequest).promise()
                if (!registryOutput.Body) {
                    console.log(`Did not find Documentation Registry file`);
                    return;
                }
                const registry: DocumentationRegistry = JSON.parse(registryOutput.Body.toString());
                this.registryItems = registry.items || [];
                this.registryItems
                    .forEach((item: any) => {
                        item.tagsAsString = (item.tags || []).join('.');
                    });
                for (let i = 0; i < this.registryItems.length; i++) {
                    this.registryItems[i].downloadUrl = await this.toDownloadUrl(this.registryItems[i]);
                }
            } else {
                const response = await this.awsUtil.webAPICall<DocumentationResponse>(WebApiEndpoints.DocumentationRequest,
                    { type: 'REGISTRY' } as DocumentationRequest, true);
                const registry = response.registry;
                this.registryItems = registry.items || [];
                this.registryItems
                    .forEach((item: any) => {
                        item.tagsAsString = (item.tags || []).join('.');
                    });
            }
        } finally {
            this.loading = false;
        }

    }

    onShowVideo(item: DocumentationRegistryItem) {
        this.selectedRegistryItem = item;
        const tenantId = this.appConfig.getTenantInfo().tenantId;
        const bucket = `com-liquitics-operations-${tenantId}`;
        const s3 = new S3(this.documentationCredentials);
        const signedUrlExpireSeconds = 60 * 5;
        s3.getSignedUrlPromise('getObject', {
            Bucket: bucket,
            Key: item.key,
            Expires: signedUrlExpireSeconds
        })
            .then((url) => {
                this.videoURL = url;
            })

    }

    async toDownloadUrl(item: DocumentationRegistryItem): Promise<string> {
        // const buffer = Buffer.from(output, 'base64');
        // const blobType = (previewFormat === 'XLSX') ?
        //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
        // const blob: any = new Blob([buffer], { type: blobType });
        // this.downloadUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
        this.selectedRegistryItem = item;
        const tenantId = this.appConfig.getTenantInfo().tenantId;
        const bucket = `com-liquitics-operations-${tenantId}`;
        const s3 = new S3(this.documentationCredentials);
        const signedUrlExpireSeconds = 60 * 5;
        return s3.getSignedUrlPromise('getObject', {
            Bucket: bucket,
            Key: item.key,
            Expires: signedUrlExpireSeconds
        });
    }

    onDownloadDocument(item: DocumentationRegistryItem) {
        this.selectedRegistryItem = item;
        const tenantId = this.appConfig.getTenantInfo().tenantId;
        const bucket = `com-liquitics-operations-${tenantId}`;
        const s3 = new S3(this.documentationCredentials);
        const signedUrlExpireSeconds = 60 * 5;
        s3.getSignedUrlPromise('getObject', {
            Bucket: bucket,
            Key: item.key,
            Expires: signedUrlExpireSeconds
        })
            .then((url) => {
                this.videoURL = url;
            })

    }

    // async getDocumentation() {
    //     s3.listObjectsV2({
    //         Bucket: bucket,
    //         Prefix: 'docs/videos/',
    //     } as S3.Types.ListObjectsV2Request).promise()
    //         .then((result) => {
    //             (result.Contents || [])
    //                 .map((obj) => {
    //                     obj.Key
    //                 })
    //         });


    // }

}
